import React from 'react'
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'

interface SidebarItemProps {
  path: string
  text: string
  icon?: JSX.Element
  open: boolean
  onClick?: (ev: React.MouseEvent) => void
  drawerTxtColor: string
  drawerActiveTxtColor: string
}

const SidebarItem: React.FC<SidebarItemProps> = ({ path, text, icon, onClick, open, drawerTxtColor, drawerActiveTxtColor }) => {
  const location = useLocation()
  const isActive = location.pathname === path

  return (
    <ListItem disablePadding sx={{ py: 0.2 }}>
      <ListItemButton
        component={path && !onClick ? Link : 'button'}
        to={path && !onClick ? path : undefined}
        onClick={onClick}
        sx={{
          py: 0,
          minHeight: 40,
          backgroundColor: isActive ? 'primary.main' : 'transparent',
          color: isActive ? drawerActiveTxtColor : drawerTxtColor,
          borderRadius: 3,
          '&:hover': {
            backgroundColor: isActive ? 'primary.main' : 'rgba(255, 255, 255, 0.04)',
            color: drawerActiveTxtColor,
            '& .MuiListItemIcon-root': {
              color: drawerActiveTxtColor,
            },
          },
        }}>
        {icon && (
          <ListItemIcon
            sx={{
              color: isActive ? drawerActiveTxtColor : drawerTxtColor,
              minWidth: 0,
              justifyContent: 'center',
              mr: open ? 1 : 'auto',
            }}>
            {icon}
          </ListItemIcon>
        )}

        <ListItemText primaryTypographyProps={{ fontSize: '13px' }} primary={text} sx={{ opacity: open ? 1 : 0 }} />
      </ListItemButton>
    </ListItem>
  )
}

export default SidebarItem
